import { useState } from 'react';
import { Download, X, Share, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui';
import { usePWAInstall } from '@/hooks/usePWAInstall';
import { cn } from '@/lib/utils';

export function InstallBanner() {
  const { showBanner, canInstall, platform, isInstalled, install, dismissBanner } = usePWAInstall();
  const [installing, setInstalling] = useState(false);

  if (!showBanner || isInstalled) return null;

  const handleInstall = async () => {
    setInstalling(true);
    await install();
    setInstalling(false);
  };

  return (
    <div className={cn(
      'fixed bottom-0 left-0 right-0 z-50 safe-area-bottom',
      'bg-primary text-primary-foreground shadow-lg',
      'animate-in slide-in-from-bottom-full duration-300',
    )}>
      <div className="flex items-center gap-3 px-4 py-3 max-w-lg mx-auto">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Instalar QOps</p>
          {platform === 'ios' ? (
            <p className="text-xs opacity-80 mt-0.5">
              Toca <Share className="inline h-3 w-3 -mt-0.5" /> y luego &quot;Agregar a pantalla de inicio&quot;
            </p>
          ) : (
            <p className="text-xs opacity-80 mt-0.5">
              Acceso rápido desde tu pantalla de inicio
            </p>
          )}
        </div>
        {canInstall && (
          <Button
            size="sm"
            variant="secondary"
            className="shrink-0"
            onClick={handleInstall}
            disabled={installing}
          >
            {installing ? (
              <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
            ) : (
              <Download className="h-3.5 w-3.5 mr-1" />
            )}
            Instalar
          </Button>
        )}
        <button
          onClick={dismissBanner}
          className="shrink-0 p-1 rounded-full hover:bg-primary-foreground/20 transition-colors"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
